import { Component, type ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children: ReactNode }, { err?: any }> {
  state = { err: undefined as any };
  static getDerivedStateFromError(err: any) { return { err }; }
  componentDidCatch(err: any, info: any) { console.error('[Boundary]', err, info); }
  render() {
    if (this.state.err) {
      const msg = String((this.state.err && (this.state.err.message || this.state.err)) || 'Unknown error');
      return (
        <div style={{ padding: 16, color: 'white' }}>
          <h2>Something broke</h2>
          <pre>{msg}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}


